import { SearchItem } from './module';

export const KeywordModuleId = 'Keyword' as const;

//Legacy

//V1
export interface KeywordSearchItemDataV1 {
  keyword: string;
  isTrending?: boolean;
}

export const KeywordSearchItemVersionV1 = '1' as const;

export interface KeywordSearchItemV1 extends SearchItem<KeywordSearchItemDataV1> {
  version: typeof KeywordSearchItemVersionV1;
  moduleId: typeof KeywordModuleId;
}

export type LegacyKeywordSearchItem = KeywordSearchItemV1;

// Current

export type KeywordSearchItemData = KeywordSearchItemDataV1;

export const KeywordSearchItemVersion = KeywordSearchItemVersionV1;

export type KeywordSearchItem = KeywordSearchItemV1;

export const isLegacyKeywordSearchItem = (item: SearchItem): item is LegacyKeywordSearchItem =>
  item.moduleId === KeywordModuleId;

export const isKeywordSearchItem = (item: SearchItem): item is KeywordSearchItem =>
  item.moduleId === KeywordModuleId && item.version === KeywordSearchItemVersion;

export const createKeywordSearchItem = (keyword: string, isTrending?: boolean): KeywordSearchItem => ({
  data: {
    isTrending,
    keyword,
  },
  id: keyword,
  moduleId: KeywordModuleId,
  version: KeywordSearchItemVersion,
});
